import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, InputAdornment, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { postUrl } from '@utils/ApiAction';
import useNotificationLoading from '@utils/useNotificationLoading';

import { FiMail, FiMessageSquare, FiUser } from 'react-icons/fi';

export default function ContactUs() {
    const { t } = useTranslation();
    const { addAlert, setLoading } = useNotificationLoading();

    const [state, setState] = useState({
        email: '',
        username: '',
        subject: '',
        message: '',
    });
    const [wordCount, setWordCount] = useState(0);
    const [inputErrors, setInputErrors] = useState();

    const handleChange = ({ target }) => {
        const { name, value } = target;
        setState(prevState => {
            if (name === 'message') {
                if (value.length <= 250) {
                    setWordCount(value.length);
                    return { ...prevState, [name]: value };
                }
                return prevState;
            }
            return { ...prevState, [name]: value };
        });
    }

    const contactUs = () => {
        setLoading(true);
        setInputErrors();
        postUrl('/user/contact-us', state).then(response => {
            setLoading(false);
            if (response.status) {
                setState({
                    email: '',
                    username: '',
                    subject: '',
                    message: '',
                });
                addAlert('', response.message, 'success', '');
            } else {
                setInputErrors(response.errors);
                addAlert('', response.message, 'error', '');
            }
        }).catch((error) => {
            setLoading(false);
            addAlert('', error.message || t('error.contactSupport'), 'error', '');
        });
    }

    return (
        <div>
            <div style={{ width: 200, margin: '0 auto 0'}}>
                <img src='/images/setting/contact-us.png' alt="contact-us" className='w-full' />
            </div>
            <div className='textfield-bkg cl-white' >
                <div className='txt-center'>
                    <p className='fs-19 inter-bold cl-theme'>{t('title.contactUs')}</p>
                    <p className='inter-normal fs-13 cl-label lh-12 p-t-5'>{t('settingDescription.contactUs')}</p>
                </div>
                <div>
                    <div className='p-t-20 w-full flex-col-m' style={{ gap: 10 }}>
                        <div>
                            <p className='fs-14 cl-label'>{t('user.username')}</p>
                            <TextField
                                variant="outlined"
                                // label={t('user.username')}
                                fullWidth
                                type="text"
                                name="username"
                                autoComplete="username"
                                color='primary'
                                value={state.username}
                                onChange={handleChange}
                                helperText={inputErrors && inputErrors.username ? inputErrors.username : ''}
                                error={inputErrors && inputErrors.username ? true : false}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <FiUser className="img-style fs-18" style={{ color: '#ffffff' }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                        <div>
                            <p className='fs-14 cl-label'>{t('user.email')}</p>
                            <TextField
                                variant="outlined"
                                // placeholder={t('user.email')}
                                fullWidth
                                type="email"
                                name="email"
                                autoComplete="email"
                                color='primary'
                                value={state.email}
                                onChange={handleChange}
                                helperText={inputErrors && inputErrors.email ? inputErrors.email : ''}
                                error={inputErrors && inputErrors.email ? true : false}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <FiMail className="img-style fs-18" style={{ color: '#ffffff' }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                        <div>
                            <p className='fs-14 cl-label'>{t('user.subject')}</p>
                            <TextField
                                variant="outlined"
                                // placeholder={t('user.subject')}
                                fullWidth
                                type="text"
                                name="subject"
                                color='primary'
                                value={state.subject}
                                onChange={handleChange}
                                helperText={inputErrors && inputErrors.subject ? inputErrors.subject : ''}
                                error={inputErrors && inputErrors.subject ? true : false}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <FiMessageSquare className="img-style fs-18" style={{ color: '#ffffff' }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                        <div>
                        <p className='fs-14 cl-label'>{t('user.message')}</p>
                        <TextField
                            multiline
                            // placeholder={t('user.message')}
                            fullWidth
                            type="text"
                            name="message"
                            color='primary'
                            value={state.message}
                            onChange={handleChange}
                            helperText={inputErrors && inputErrors.message ? inputErrors.message : ''}
                            error={inputErrors && inputErrors.message ? true : false}
                        />
                        <p className='txt-right p-t-8 fs-10 cl-label'>{t('user.maximumChar')} {wordCount} / 250</p>
                        </div>
                    </div>
                    <div className='p-t-20'>
                        <Button variant="contained" color="primary" size="large" onClick={contactUs} fullWidth><p className='txt-upper' style={{ fontWeight: 600 }}>{t('button.submit')}</p></Button>
                    </div>
                </div>
            </div>
        </div>
    );
}